
import { Component, Vue, Watch, Prop, Inject } from "vue-property-decorator"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import ScrollTab from "./ScrollTab.vue"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar
	}
})
export default class TabButton extends Vue {
	@Prop()
	tab!: ScrollTab | null;

	get tabActive () {
		if (!this.tab) {
			return false
		}

		return this.tab.active
	}

	get Contents () {
		if (!this.tab) {
			return null
		}

		if (this.tab.$scopedSlots["title"]) {
			const titleSlot = this.tab.$scopedSlots["title"]
			if (titleSlot) return titleSlot({})
		}

		return this.tab.title
	}

	makeActive () {
		if (!this.tabActive) {
			this.$emit("setTab", this.tab)
		}
	}
}

